<div class="bg-gray-100 h-full flex flex-col overflow-hidden">
  <!-- Tabs -->
  <div class="flex-shrink-0 border-b border-gray-200 px-4">
    <div class="flex">
      <button (click)="changeTab('sales')" class="px-6 py-3 font-semibold transition-colors border-b-2"
        [class]="activeTab() === 'sales' ? 'border-indigo-600 text-indigo-700' : 'border-transparent  hover:text-gray-800 hover:border-gray-300'">
        {{ 'REVENSTR0001' | translate }}
      </button>
      <button (click)="changeTab('receipt')" class="px-6 py-3 font-semibold transition-colors border-b-2"
        [class]="activeTab() === 'receipt' ? 'border-indigo-600 text-indigo-700' : 'border-transparent  hover:text-gray-800 hover:border-gray-300'">
        {{ 'RECPTSTR0001' | translate }}
      </button>
      <button (click)="changeTab('staff')" class="px-6 py-3 font-semibold transition-colors border-b-2"
        [class]="activeTab() === 'staff' ? 'border-indigo-600 text-indigo-700' : 'border-transparent  hover:text-gray-800 hover:border-gray-300'">
        {{ 'SALEESTR0001' | translate }}
      </button>
    </div>
  </div>

  <!-- Main Content Area -->
  <div class="flex-1 min-h-0  border-gray-200 rounded-b-xl shadow-sm flex flex-col p-2">
    @if (activeTab() === 'sales') {
    <!-- Sales Inquiry Filters -->
    <div class="flex justify-between bg-white border-x border-b">
      <div class="flex flex-row gap-2 p-2">
        <div class="flex flex-wrap items-center gap-4 w-full lg:w-auto">
          <!-- <label class="  whitespace-nowrap">{{ 'REVENSTR0003' | translate }}</label> -->
          <div class="flex gap-2">
            <p-datepicker [iconDisplay]="'input'" [locale]="locale" [(ngModel)]="param.START_DT1" [showIcon]="true"
              appendTo="body" [readonlyInput]="true" [dateFormat]="'yy-mm-dd'" (keydown.enter)="getSale()"
              (ngModelChange)="onStartDateChange(1)" class="w-[130px] 2xl:w-full"
              inputStyleClass="w-[130px] 2xl:w-full" />
            <span class="fw-500 fs-16 flex items-center">-</span>
            <p-datepicker [iconDisplay]="'input'" [locale]="locale" [(ngModel)]="param.END_DT1" [showIcon]="true"
              appendTo="body" [readonlyInput]="true" [dateFormat]="'yy-mm-dd'" (keydown.enter)="getSale()"
              class="w-[130px] 2xl:w-full" inputStyleClass="w-[130px] 2xl:w-full"
              (ngModelChange)="onEndDateChange(1)" />
          </div>
          <div>
            <p-selectButton [options]="weekButtons" [(ngModel)]="selectedWeek1" [multiple]="false"
              (onChange)="onWeekChange($event, 1)" optionValue="value" optionLabel="label"
              [className]="'flex text-ellipsis gap-2'" />
          </div>
        </div>
      </div>
      <div class="flex gap-2 w-full lg:w-auto p-2">
        <button (click)="reset()"
          class="flex-1 h-[37px] lg:flex-none px-5 py-2.5 bg-gray-600 text-white  rounded-md hover:bg-gray-700 transition-colors flex items-center justify-center gap-2 shadow-sm w-[100px]">
          {{ 'REVENSTR0008' | translate }}</button>
        <button (click)="getSale()"
          class="flex-1 h-[37px] lg:flex-none px-5 py-2.5 bg-gray-600 text-white  rounded-md hover:bg-gray-700 transition-colors flex items-center justify-center gap-2 shadow-sm w-[100px]">
          {{ 'REVENSTR0009' | translate }}</button>
      </div>
    </div>

    <!-- Sales Inquiry Table -->
    <div class="h-2"></div>
    <app-material-table class="h-full min-h-0" [headers]="salesHeaders()" [data]="salesData()" [width]="'w-full'"
      [rowTemplate]="salesRowTpl" [enablePagination]="true" [key]="'no'" (nextPage)="nextPageSale($event)"
      [isPaging]="true" [isNextPage]="isNextPageSale()" [pageSize]="P_PAGEROW"
      [totalCnt]="totalCntSale()"></app-material-table>

    <ng-template #salesRowTpl let-item>
      <tr class=" text-center border-b last:border-b-0 hover:bg-gray-50/50">
        <td class="p-[0.4rem] border-r border-gray-200  border-b sticky left-0 z-30 w-[54px] bg-white">{{ item.no }}
        </td>
        <td
          class="p-[0.4rem] border-r border-gray-200 text-center border-b sticky left-[54px] w-[140px] z-30 bg-white truncate">
          {{ item.salE_DT}}</td>
        <td class="p-[0.4rem] border-r border-gray-200 text-right  border-b">{{ item.toT_SALE_AMT | number}}</td>
        <td class="p-[0.4rem] border-r border-gray-200 text-right  border-b ">{{ item.toT_DC_AMT | number}}</td>
        <td class="p-[0.4rem] border-r border-gray-200 text-right  border-b">{{ item.neT_SALE_AMT | number}}</td>
        <td class="p-[0.4rem] border-r border-gray-200 text-right  border-b">{{ item.salE_NO_CNT | number}}</td>
        <td class="p-[0.4rem] border-r border-gray-200 text-right  border-b">{{ item.cusT_COST | number}}</td>
        <td class="p-[0.4rem] border-r border-gray-200 text-right  border-b">{{ item.canceL_CNT | number}}</td>
        <td class="p-[0.4rem] border-r border-gray-200 text-right  border-b">{{ item.canceL_SALE_AMT | number}}</td>
        <td class="p-[0.4rem] border-r border-gray-200 text-right  border-b">{{ item.casH_AMT | number}}</td>
        <td class="p-[0.4rem] border-r border-gray-200 text-right  border-b">{{ item.carD_AMT | number}}</td>
        <td class="p-[0.4rem] border-r border-gray-200 text-right  border-b">{{ item.easY_AMT | number}}</td>
        <td class="p-[0.4rem] border-r border-gray-200 text-right  border-b">{{ item.cahrgE_USE_AMT | number}}</td>
        <td class="p-[0.4rem] border-r border-gray-200 text-right  border-b">{{ item.etc | number}}</td>
      </tr>
    </ng-template>

    } @else if (activeTab() === 'receipt') {
    <div class="flex justify-between bg-white border-x border-b gap-2 p-2">
      <div class="flex flex-wrap items-center gap-4 w-full lg:w-auto">
        <div class="flex gap-2">
          <p-datepicker [iconDisplay]="'input'" [locale]="locale" [(ngModel)]="param.START_DT3" [showIcon]="true"
            appendTo="body" [readonlyInput]="true" [dateFormat]="'yy-mm-dd'" (keydown.enter)="getReceiptInquiry()"
            (ngModelChange)="onStartDateChange(3)" class="w-[130px] 2xl:w-full"
            inputStyleClass="w-[130px] 2xl:w-full" />
          <span class="fw-500 fs-16 flex items-center">-</span>
          <p-datepicker [iconDisplay]="'input'" [locale]="locale" [(ngModel)]="param.END_DT3" [showIcon]="true"
            appendTo="body" [readonlyInput]="true" [dateFormat]="'yy-mm-dd'" (keydown.enter)="getReceiptInquiry()"
            (ngModelChange)="onEndDateChange(3)" class="w-[130px] 2xl:w-full" inputStyleClass="w-[130px] 2xl:w-full" />
        </div>
        <div>
          <p-selectButton [options]="weekButtons" [(ngModel)]="selectedWeek3" [multiple]="false"
            (onChange)="onWeekChange($event, 3)" optionValue="value" optionLabel="label"
            [className]="'flex text-ellipsis gap-2'" />
        </div>
      </div>
      <div class="flex gap-2 w-full lg:w-auto mx-2">
        <button (click)="resetReceipt()"
          class="flex-1 lg:flex-none px-5 py-2.5 bg-gray-600 text-white  rounded-md hover:bg-gray-700 transition-colors flex items-center justify-center gap-2 shadow-sm w-[100px]">
          {{ 'REVENSTR0008' | translate }}</button>
        <button (click)="getReceiptInquiry()"
          class="flex-1 lg:flex-none px-5 py-2.5 bg-gray-600 text-white  rounded-md hover:bg-gray-700 transition-colors flex items-center justify-center gap-2 shadow-sm w-[100px]">
          {{ 'REVENSTR0009' | translate }}</button>
      </div>
    </div>
    <div class="h-2"></div>
    <!-- Receipt Inquiry Filters -->
    <div class="flex-1 grid grid-cols-1 xl:grid-cols-2 gap-4 overflow-hidden">
      <div class="flex flex-col overflow-hidden h-full">
        <div class="flex justify-between items-center mb-2 px-1">
          <h3 class=" ">{{ 'RECPTSTR0008' | translate }}</h3>
          <button [class]="selectedReceipt() ? 'bg-gray-600' : 'bg-gray-400 pointer-events-none'"
            class="px-3 py-1 text-white border border-gray-300 rounded hover:bg-gray-700" (click)="print()">{{
            'RECPTSTR0009' | translate }}</button>
        </div>
        <app-material-table class="h-full min-h-0" [headers]="receiptHeaders()" [data]="receipts()" [width]="'w-full'"
          [rowTemplate]="receiptRowTpl" [enablePagination]="true" [key]="'no'" [pageSize]="P_PAGEROW"
          (nextPage)="nextPageReceipt($event)" [totalCnt]="totalCntReceipt()" [isPaging]="true"
          [isNextPage]="isNextPageReceipt()"></app-material-table>

        <ng-template #receiptRowTpl let-receipt>
          <tr class="h-10  text-center hover:bg-indigo-50 cursor-pointer"
            [class.bg-indigo-100]="selectedReceipt()?.no === receipt.no" (click)="selectReceipt(receipt)">
            <td class="p-[0.4rem] border-r  border-b">{{receipt.no}}</td>
            <td class="p-[0.4rem] border-r  border-b truncate">{{receipt.salE_DT}}</td>
            <td class="p-[0.4rem] border-r  border-b">{{receipt.salE_NO}}</td>
            <td class="p-[0.4rem] border-r  border-b text-right px-2">{{receipt.neTSALE_AMT | number}}
            </td>
            <td class="p-[0.4rem] border-r  border-b">{{receipt.hP_NO | phoneFormat}}</td>
            <td class="p-[0.4rem] border-b">{{receipt.iS_CANCELED == 'Y' ? '반품원거래' : receipt.sale_tp_nm}}</td>
          </tr>
        </ng-template>
      </div>
      <!-- Receipt Details -->
      <div class="flex flex-col overflow-hidden h-full">
        <div class="flex justify-between items-center mb-2 px-1">
          <h3 class=" ">{{ 'RECPTSTR0016' | translate }}</h3>
          <button class="px-3 py-1  border  text-white rounded hover:bg-red-700" (click)="showConfirmDelete.set(true)"
            [class]="selectedReceipt()?.salE_TP == '01' || selectedReceipt()?.iS_CANCELED == 'Y' || !selectedReceipt() ? 'bg-gray-300 pointer-events-none' : 'bg-red-600 border-red-700'">
            {{'RECPTSTR0017'| translate}}
          </button>
        </div>
        @if(selectedReceipt(); as receipt) {
        <div class="flex-1 overflow-y-auto bg-white border border-gray-200 rounded-lg shadow-inner">
          <!-- <app-receipt-preview [receiptData]="receiptPreviewData" [selectedReceipt]="selectedReceipt()"
            [services]="trServices" /> -->
          <pre>
          {{ billPreview() }}
          </pre>
        </div>
        } @else {
        <div class="flex-1 flex items-center justify-center bg-gray-50 border border-gray-200 rounded-lg">
          <p class="text-gray-400 text-sm">{{'SYSMESER0004' | translate}}</p>
        </div>
        }
      </div>
    </div>
    } @else if (activeTab() === 'staff') {
    <div class="flex justify-between bg-white border-x border-b gap-2">
      <div class="flex flex-wrap items-center gap-4 w-full lg:w-auto">
        <div class="flex gap-6">
          <div class="flex gap-2 ms-2">
            <p-datepicker [iconDisplay]="'input'" [(ngModel)]="param.START_DT2" [showIcon]="true" appendTo="body"
              [readonlyInput]="true" [locale]="locale" [dateFormat]="'yy-mm-dd'" (keydown.enter)="getSaleByStaff()"
              (ngModelChange)="onStartDateChange(2)" class="w-[130px] 2xl:w-full"
              inputStyleClass="w-[130px] 2xl:w-full" />
            <span class="fw-500 fs-16 flex items-center">-</span>
            <p-datepicker [iconDisplay]="'input'" [locale]="locale" [(ngModel)]="param.END_DT2" [showIcon]="true"
              appendTo="body" [readonlyInput]="true" [dateFormat]="'yy-mm-dd'" (keydown.enter)="getSaleByStaff()"
              (ngModelChange)="onEndDateChange(2)" class="w-[130px] 2xl:w-full"
              inputStyleClass="w-[130px] 2xl:w-full" />
            <div>
              <p-selectButton [options]="weekButtons" [(ngModel)]="selectedWeek2" [multiple]="false"
                (onChange)="onWeekChange($event, 2)" optionValue="value" optionLabel="label"
                [className]="'flex text-ellipsis gap-2'" />
            </div>
          </div>
          <div class="flex items-center">
            <p-select [options]="staffList" [(ngModel)]="selectedStaff" optionLabel="useR_NM" optionValue="useR_ID"
              class="w-[120px] 2xl:w-[200px] h-[37px]" filter="true" filterBy="useR_NM"
              [placeholder]="'REVENSTR0027' | translate" [showClear]="true" />
          </div>
        </div>
      </div>
      <div class="flex gap-2 w-full lg:w-auto p-2">
        <button (click)="resetByStaff()"
          class="flex-1 lg:flex-none h-[37px] p-2 bg-gray-600 text-white  rounded-md hover:bg-gray-700 transition-colors flex items-center justify-center gap-2 shadow-sm w-[80px] 2xl:w-[100px]">
          {{ 'SALEESTR0024' | translate }}</button>
        <button (click)="getSaleByStaff()"
          class="flex-1 lg:flex-none h-[37px] p-2 bg-gray-600 text-white  rounded-md hover:bg-gray-700 transition-colors flex items-center justify-center gap-2 shadow-sm w-[80px] 2xl:w-[100px]">
          {{ 'SALEESTR0025' | translate }}</button>
      </div>
    </div>
    <div class="h-2"></div>
    <div class="flex-1 grid grid-cols-1 xl:grid-cols-2 gap-4 overflow-hidden">
      <div class="flex flex-col h-full">
        <label class="mb-2 px-1">{{ 'SALEESTR0009' | translate }}</label>
        <app-material-table class="h-full min-h-0" [headers]="staffSalesHeaders()" [key]="'no'" [width]="'w-full'"
          [data]="staffSales()" [rowTemplate]="staffSaleRowTpl" [enablePagination]="true" [pageSize]="P_PAGEROW"
          (nextPage)="nextPageStaff($event)" [totalCnt]="totalCntStaffSales()" [isPaging]="true"
          [isNextPage]="isNextPageStaffSales()"></app-material-table>
        <ng-template #staffSaleRowTpl let-sale>
          <tr (click)="selectStaffSale(sale)" class="h-10  text-center hover:bg-indigo-50 cursor-pointer"
            [class.bg-indigo-100]="selectedStaffSale()?.no === sale.no">
            <td class="p-[0.4rem]  border-r border-b sticky left-0 w-[54px] z-30 "
              [class.bg-white]="selectedStaffSale()?.no !== sale.no"
              [class.bg-indigo-100]="selectedStaffSale()?.no === sale.no">{{sale.no}}</td>
            <td class="p-[0.4rem] h-[35px] border-r border-b text-left sticky left-[49px] w-[149px] z-30"
              [class.bg-white]="selectedStaffSale()?.no !== sale.no"
              [class.bg-indigo-100]="selectedStaffSale()?.no === sale.no">
              <span class="w-full text-ellipsis">{{sale.useR_NM}}</span>
            </td>
            <td class="p-[0.4rem] border-r border-b text-center sticky left-[145px] w-[120px] z-30 truncate"
              [class.bg-white]="selectedStaffSale()?.no !== sale.no"
              [class.bg-indigo-100]="selectedStaffSale()?.no === sale.no">
              {{sale.salE_DTYMD}}</td>
            <td class="p-[0.4rem] border-r border-b text-right px-2">{{sale.salE_NO_CNT | number}}</td>
            <td class="p-[0.4rem] text-right border-r border-b px-2">{{sale.toT_SALE_AMT | number}}</td>
            <td class="p-[0.4rem] text-right border-b px-2">{{sale.neT_SALE_AMT | number}}</td>
          </tr>
        </ng-template>
      </div>
      <div class="flex flex-col h-full">
        <label class="mb-2 px-1">{{ 'SALEESTR0016' | translate }}</label>
        <app-material-table class="h-full min-h-0" [headers]="staffDetailsHeaders()" [width]="'w-full'"
          [data]="staffSaleDetails()" [rowTemplate]="staffDetailRowTpl" [enablePagination]="true" [pageSize]="P_PAGEROW"
          [totalCnt]="staffSaleDetails().length"></app-material-table>
        <ng-template #staffDetailRowTpl let-detail>
          <tr class="h-10  text-center">
            <td class="p-[0.4rem] border-r   border-b sticky left-0 w-[54px] z-30 bg-white">{{detail.no}}
            </td>
            <td class="p-[0.4rem] border-r    border-b sticky left-[48px] w-[120px] z-30 bg-white truncate">
              {{detail.salE_DT}}</td>
            <td class="p-[0.4rem] border-r   border-b">{{detail.salE_NO}}</td>
            <td class="p-[0.4rem] border-r  border-b truncate">{{detail.salE_TP_NM}}</td>
            <td class="p-[0.4rem] border-r   text-right px-2  border-b">{{detail.toT_SALE_AMT | number}}
            </td>
            <td class="p-[0.4rem] border-r  text-right px-2  border-b">{{detail.toT_DC_AMT | number}}
            </td>
            <td class="p-[0.4rem] border-r  text-right px-2  border-b">{{detail.neT_SALE_AMT | number}}
            </td>
          </tr>
        </ng-template>
      </div>
    </div>
    }
  </div>
</div>

<app-pop-up-common [showConfirm]="showConfirmDelete()" (confirmEvent)="onClickCancelSale()"
  (cancelEvent)="showConfirmDelete.set(false)" [message]="'RECPTSTR0094'"></app-pop-up-common>


@if(loading()){
<div class="loading-overlay">
  <div class="flex flex-col justify-center gap-4">
    <div class="flex items-center justify-center text-white w-full">
      <p>{{ loadingText() }}</p>
    </div>
    <div class="flex justify-center w-full">
      <div class="loader"></div>
    </div>
  </div>
</div>
}